import { render, staticRenderFns } from "./FloatView.vue?vue&type=template&id=71afbdca"
import script from "./FloatView.vue?vue&type=script&lang=js"
export * from "./FloatView.vue?vue&type=script&lang=js"
import style0 from "./FloatView.vue?vue&type=style&index=0&id=71afbdca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports